import React from 'react';

import { SvgProps } from 'components/UI/Svg/Svg';
import { SNavStyles } from './index';
import { getFillColor, getStrokeColor } from './utils';

export default (props: SvgProps | undefined) => {
  const getFill = getFillColor(
    props?.active,
    props?.activeFillColor,
    props?.disabled,
    props?.disabledColor,
    props?.color
  );
  const getStroke = getStrokeColor(
    props?.active,
    props?.activeStrokeColor,
    props?.disabled,
    props?.disabledColor,
    props?.color
  );

  return {
    svg: (
      <g {...SNavStyles} fill={getFill} stroke={getStroke}>
        <polyline points="4.2,14.45 17.98,4.74 31.74,14.18 " />
        <polyline points="6.4,12.86 6.4,30.89 15.25,30.89 15.25,21.88 20.85,21.88 20.85,30.89 29.24,30.89 29.1,12.86 " />
      </g>
    ),
    viewBox: '0 0 36 36'
  };
};
